import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import MegaMenuAutomotiveDepartment from './MegaMenuAutomotiveDepartment.vue';
import MegaMenuDepartment from './MegaMenuDepartment.vue';
import VIntersectionObserver from 'JS/components/VIntersectionObserver.vue';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { IBannerXAd } from 'JS/sponsored/sponsored-types';
import { IWebSiteMenu, MenuLinkType } from 'Src/js/types/Header';
import { useEventListener } from 'JS/composables/event-listener';


export default /*#__PURE__*/_defineComponent({
  __name: 'MegaMenu',
  props: {
    departments: null,
    megaMenuAd: null
  },
  emits: ["close", "get-mega-menu-ad", "record-ad-impression"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'close'): void;
	(event: 'get-mega-menu-ad'): void;
	(event: 'record-ad-impression'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	departments: IWebSiteMenu[];
	megaMenuAd?: IBannerXAd;
}





const megaMenuRef = ref<HTMLElement>(null);
const activeMenuId = ref<string>("");
const automotiveMenuId: string = "12";
const animalRxMenuId: string = "13";

const automotiveMenuItem = computed(()=> {
	return props.departments.find(x => x.id === automotiveMenuId);
});

const animalRxMenuItem = computed(()=> {
	return props.departments.find(x => x.id === animalRxMenuId);
});

const accessibleText = computed<string>(() => {
	const sponsored = "Sponsored ";
	if (props.megaMenuAd?.bannerImageAccessibleText === props.megaMenuAd?.ctaAccessibleText) {
		return sponsored + props.megaMenuAd?.bannerImageAccessibleText;
	} else {
		return sponsored + props.megaMenuAd?.bannerImageAccessibleText + " " + props.megaMenuAd?.ctaAccessibleText;
	}
});

useEventListener(window, 'click', e => {
	if (megaMenuRef.value && !megaMenuRef.value.contains(e.target as Node)) {
		e.preventDefault();
		emit('close');
	}
});

onMounted(()=> {
	const content = document.getElementById('contentWrapper');
	if (!content) return;
	content.classList.add('shadowed');

	emit('get-mega-menu-ad');
});

onUnmounted(()=> {
	const content = document.getElementById('contentWrapper');
	if (!content) return;
	content.classList.remove('shadowed');
});

function toggleDepartment(departmentId: string) {
	activeMenuId.value = activeMenuId.value !== departmentId ? departmentId : "";
}

function handleMenuClick(menuLevel: number, linkType: MenuLinkType = 'other') {
	window.blainGtmDataLayer.push({
		'menuName': "main",
		'menuLevel': menuLevel,
		'menuLinkType': linkType,
		'event': "menu_click"
	});
}

function recordAdClick() {
	navigator.sendBeacon('/event/a/sponsored-ad-click', JSON.stringify(props.megaMenuAd.adId));
}

watch(()=> props.departments, (departmentsNew: IWebSiteMenu[]) => {
	if (!departmentsNew?.length) return;

	activeMenuId.value = departmentsNew[0].id;
});



return { __sfc: true,props, emit, megaMenuRef, activeMenuId, automotiveMenuId, animalRxMenuId, automotiveMenuItem, animalRxMenuItem, accessibleText, toggleDepartment, handleMenuClick, recordAdClick, Icon, MegaMenuAutomotiveDepartment, MegaMenuDepartment, VIntersectionObserver }
}

})